import {
  type ReportConfigData,
  type ReportConfigListInput,
  type ReportConfigListSuccess,
  type ReportConfigType,
  type SavedReportConfigData,
  type ScheduledReportConfigData,
} from '@terros/common'
import { useTantalimQuery } from '../../query'
import { reportConfigListKey } from '../../keys'
import { type GetHookResponse } from '../../hooks'

export function useReportConfigs(configType?: ReportConfigType): GetHookResponse<ReportConfigData[]> {
  return useTantalimQuery<ReportConfigListInput, ReportConfigListSuccess, ReportConfigData[]>({
    url: '/report/config/list',
    queryKey: reportConfigListKey(configType),
    input: { configType },
    convertResponse: (data) => data.reportConfigs,
  })
}

export function useScheduledReportConfigs(): GetHookResponse<ScheduledReportConfigData[]> {
  const { data, ...rest } = useReportConfigs('scheduled')
  const configs = data?.filter((c) => c.configType === 'scheduled')
  return {
    data: configs,
    ...rest,
  }
}

export function useSavedReportConfigs(): GetHookResponse<SavedReportConfigData[]> {
  const { data, ...rest } = useReportConfigs('saved')
  const configs = data?.filter((c) => c.configType === 'saved')
  return {
    data: configs,
    ...rest,
  }
}
